// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SpaceBreadCrumbs_wrapper__2jCAo","condensedText":"SpaceBreadCrumbs_condensedText__2Zh7S","dots":"SpaceBreadCrumbs_dots__38DFa"};